import { Card, CircularProgress, Container, FormControl, MenuItem, Select } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import KomponenList from 'examples/Lists/KomponenList'
import { getDataWithResponse } from 'global/getFunc'
import { postDataWithResponse } from 'global/postFunc'
import { useEffect, useState } from 'react'
import userStore from 'store/userStore'

const PaketDak = () => {
    const { addReq } = userStore(state => ({ addReq: state.addReq }));

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const d = new Date();
    const [listTa, setListTa] = useState(d.getFullYear())
    const [ta, setTa] = useState(d.getFullYear())

    useEffect(() => {
        addReq()
        getDataWithResponse(
            '/get-ta',
            null,
            (res) => {
                setListTa(res)
            },
            (res) => {
                console.log(res)
            }

        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        ta !== '' && reqProyekDak()
        console.log(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ta])

    const reqProyekDak = () => {
        addReq()
        setLoading(true)
        postDataWithResponse(
            '/komponen-belanja/dak',
            {
                ta: ta,
            },
            null,
            (res) => {
                setData(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    return (
        <ArgonBox mt={12} sx={{minHeight: '90vh'}}>
            <Container>
                <ArgonBox px={2}>
                    <Card sx={{ p: 2 }}>
                        <ArgonTypography variant="h6" fontWeight="bold" textTransform="capitalize">
                            Paket DAK
                        </ArgonTypography>
                        <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Tahun Anggaran
                        </ArgonTypography>
                    </ArgonBox>
                    <FormControl fullWidth>
                        {/* <InputLabel id="demo-simple-select-standard-label">Age</InputLabel> */}
                        <Select
                            placeholder="Select year"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={ta || ''}
                            onChange={(e) => setTa(e.target.value)}
                            required
                            // endAdornment={
                            //     loading && <CircularProgress color="inherit" size={20} />
                            // }
                        >
                            {
                                listTa.length > 0 && listTa.map((x, index) => (
                                    <MenuItem key={index} value={x.ta}>{x.ta}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                    </Card>
                </ArgonBox>
                {
                    loading ?
                        (
                            (
                                <ArgonBox align="center" mt={3}>
                                    <CircularProgress />
                                </ArgonBox>
                            )
                        )
                        :
                        (
                            <ArgonBox p={2}>
                                <KomponenList
                                    title="Proyek DAK"
                                    listData={data}
                                    showOpd={true}
                                    to='/paket/detail'
                                />
                            </ArgonBox>
                        )
                }
            </Container>
        </ArgonBox>
    )
}

export default PaketDak